import React, { useEffect, useReducer } from "react"
import { Card, CardHeader, CardBody, Spinner } from "reactstrap"
import { getPersonEdu } from "states/person/PersonDatasource"
import PersonReducer from "states/person/PersonReducer"
import { FETCH_SUCCESS, FETCH_FAILED } from "states/person/PersonType"

const INIT_DATA = {
  loading: true,
  data: null,
  itemsCount: 0,
}
export default function EducationSection({ staffId}) {
  const [state, dispatch] = useReducer(PersonReducer, INIT_DATA)

  const fetchData = async () => {
    try {
      const resp = await getPersonEdu(staffId)

      if (resp.status === 1) {
        const payload = {
          data: resp.result,
          itemsCount: resp.itemsCount
        }        
        return dispatch({ type: FETCH_SUCCESS, payload })
      } else {
        return dispatch({ type: FETCH_FAILED, error: "Fetch failed" })
      }
    } catch (error) {
      return dispatch({ type: FETCH_FAILED, error: error.message })
    }
  }

  useEffect(() => {
    if (state.loading) {
      if (staffId) {
        setTimeout(() => {
          fetchData()
        }, 1000)
      } else {
        console.log("No id to query")
      }
    }
  })

  return (
    <div className="section">
      <Card className="card-section">
        <CardHeader>
          <i className="fas fa-graduation-cap"></i>
          <span> ระดับการศึกษา</span>
        </CardHeader>
        <CardBody>
        {
            !state.data 
              ? <div className="text-center"><Spinner /></div>
              : (
                <ul className="list-unstyled list-data">
                  {
                    state.data.length > 0 ? 
                    (
                      state.data.map((item, index) => {
                        return (
                          <li key={index}>
                            <div className="year">{item.gradYear}</div>                          
                            <div className="university">{item.degree + " - " + item.university+" / "+item.major+ " / " + item.country}</div>
                          </li>
                        )
                      })
                    ) : (
                      <li>
                        <p className="text-nodata">ไม่พบข้อมูล</p>
                      </li>
                    )
                  }
                </ul>
              )
          }
        </CardBody>
      </Card>
    </div>
  )
}